import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

import AuditsList from './AuditsList';
import Dialog from '../../DesignSystem/Dialog';

function AuditsModal({ audits }: any) {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const isOpen = searchParams.get('audits_modal') === 'true';

  return (
    <Dialog
      id="post-history"
      label={intl.formatMessage({ id: 'POSTS.AUDITS.MODAL.TITLE' })}
      open={isOpen}
      title={<FormattedMessage id="POSTS.AUDITS.MODAL.TITLE" />}
      maxWidth="md"
      onClose={() => setSearchParams({})}
      disableGutters
      fullWidth
    >
      <AuditsList audits={audits} />
    </Dialog>
  );
}

export default AuditsModal;
